import {
    PredictionStatus,
    CompletionForecast,
    BudgetTrajectory,
    PhaseDistribution,
    TimelineData,
} from "../types";

// Mock data
const MOCK_PREDICTION_STATUS: PredictionStatus = {
    enabled: true,
    dataCompleteness: 100,
    description: "Data quality sufficient for bounded, credible forecasting",
};

const MOCK_COMPLETION_FORECAST: CompletionForecast = {
    earliest: "Feb 2025",
    latest: "May 2027",
    description: "All projects complete between Feb 2025 and May 2027, assuming no further delays or interventions.",
};

const MOCK_BUDGET_TRAJECTORY: BudgetTrajectory = {
    activeProjects: 30,
    activeBudget: 141.8,
    description: "Projects not yet in Closure phase represent £141.8M in delivery value.",
};

const MOCK_PHASE_DISTRIBUTION: PhaseDistribution[] = [
    { phase: "Construction", projects: 12 },
    { phase: "Detailed Design", projects: 7 },
    { phase: "Pre-Construction", projects: 6 },
    { phase: "Commissioning", projects: 2 },
    { phase: "Feasibility / Concept", projects: 2 },
    { phase: "Estimate / Validation", projects: 1 },
];

const MOCK_TIMELINE_DATA: TimelineData[] = [
    { date: "Jan 25", activeProjects: 18, completedProjects: 6 },
    { date: "Mar 25", activeProjects: 22, completedProjects: 7 },
    { date: "May 25", activeProjects: 26, completedProjects: 9 },
    { date: "Jul 25", activeProjects: 24, completedProjects: 13 },
    { date: "Sep 25", activeProjects: 20, completedProjects: 17 },
    { date: "Nov 25", activeProjects: 16, completedProjects: 21 },
    { date: "Jan 26", activeProjects: 12, completedProjects: 26 },
];

// Mock API functions
export const getPredictionStatus = async (): Promise<PredictionStatus> => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 300));
    return MOCK_PREDICTION_STATUS;
};

export const getCompletionForecast = async (): Promise<CompletionForecast> => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 400));
    return MOCK_COMPLETION_FORECAST;
};

export const getBudgetTrajectory = async (): Promise<BudgetTrajectory> => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 350));
    return MOCK_BUDGET_TRAJECTORY;
};

export const getPhaseDistribution = async (): Promise<PhaseDistribution[]> => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 450));
    return MOCK_PHASE_DISTRIBUTION;
};

export const getTimelineData = async (): Promise<TimelineData[]> => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));
    return MOCK_TIMELINE_DATA;
};
